import { useState, useEffect } from 'react';
import ProjectInput from 'domain/shared/project/input/ProjectInput';
import { EqCondition, useFilterContext, BaseFilterProps } from 'framework/list';
import { FilterCondition } from 'framework/types';
import { InputLoader } from 'framework/ui/mui-builder';
import useProjectService from '../projectService';

interface ProjectFilterProps extends BaseFilterProps {
  label?: string;
}

const setProjectLabel = (searchSuggestions: any, projectId: string, setLabel: any, setProjectIdLoaded: any) => {
  (async () => {
    const response = await searchSuggestions({
      filter: {
        id: {
          eq: projectId,
        },
      },
    });
    const procject = response && response.result && !!response.result.length && response.result[0];
    setLabel(procject.name);
    setProjectIdLoaded(true);
  })();
};

// Filter by old useProjectService
const ProjectFilter = ({ label: filterLabel, source, ...props }: ProjectFilterProps) => {
  const { filterBy, getValue } = useFilterContext();
  const { searchSuggestions: search } = useProjectService();

  const [label, setLabel] = useState('');
  const [projectIdLoaded, setProjectIdLoaded] = useState(false);

  useEffect(() => {
    const projectId = getValue(source, FilterCondition.EQ);

    if (projectId) {
      setProjectLabel(search, projectId, setLabel, setProjectIdLoaded);
    } else {
      setProjectIdLoaded(true);
    }
    // Suppressed warnings because we only need to call useEffect callback ones after the first mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChangeCallback = (filter: any) => {
    filterBy(filter);
  };

  return projectIdLoaded ? (
    <EqCondition {...props} source={source} onChangeCallback={onChangeCallback}>
      <ProjectInput
        search={search}
        mapResults={item => ({
          id: item.id,
          text: item.projectName,
        })}
        initialLabel={label}
        source={source}
        label={filterLabel}
        searchString="name"
      />
    </EqCondition>
  ) : (
    <InputLoader />
  );
};

export default ProjectFilter;
